<template>
  <div class="box">
    <div class="swiper" style="height: 100vh;">
      <swiper :options="pullSwiperOptions" 
      @transitionStart="onSlideChangeStart"
      @transitionEnd="onSlideChangeEnd"
      @slideChange="onSlideChange"
      ref="fullSwiper">
        <swiper-slide class="banner-swiper relative">
          <swiper :options="swiperOptions" ref="mySwiper" class="banner-container">
            <swiper-slide class="banner-slide">
              <img src="@/assets/img/banner1.jpg" class="banner-img banner-img1" alt="" srcset="" />
              <div class="banner-desc-box">
                <div class="desc1">互联网医院</div>
                <div class="desc2"><span class="ai">AI 赋能 </span>| 新一代智慧互联网医院</div>
              </div>
              <div @click="goPage()" class="btn4 abs1">
                了解更多
                <img src="@/assets/img/more1.png" class="more-icon1" alt="" srcset="">
              </div>
            </swiper-slide>
            <swiper-slide class="banner-slide relative">
              <img src="@/assets/img/banner2.jpg" class="banner-img banner-img1" swiper-animate-effect="fadeInDown" swiper-animate-duration="1s" swiper-animate-delay="300ms" alt="" srcset="" />
              <div class="banner-desc-box">
                <div class="desc1">统一支付对账平台</div>
                <div class="desc2">全渠道、全业务、全场景一站式支付与对账管理</div>
              </div>
              <div @click="goPage()" class="btn4 abs1">
                了解更多
                <img src="@/assets/img/more1.png" class="more-icon1" alt="" srcset="">
              </div>
            </swiper-slide>
            <swiper-slide class="banner-slide relative">
              <img src="@/assets/img/banner3.jpg" class="banner-img banner-img1" swiper-animate-effect="fadeInDown" swiper-animate-duration="1s" swiper-animate-delay="300ms" alt="" srcset="" />
              <div class="banner-desc-box">
                <div class="desc1">全资源预约平台</div>
                <div class="desc2">资源集中管理、统一预约门户、智能统筹合理高效</div>
              </div>
              <div @click="goPage()" class="btn4 abs1">
                了解更多
                <img src="@/assets/img/more1.png" class="more-icon1" alt="" srcset="">
              </div>
            </swiper-slide>
          </swiper>
          
          <div class="swiper-pagination banner-swiper-pagination"></div>
        </swiper-slide>
        <swiper-slide>
          <div class="bg2 w100 h100 flex-item-center">
            <div class="container">
              <div class="content-box about-box">
                <div class="title-box text-center">
                  <div class="title">关于惠宾</div>
                  <div class="subtitle">ABOUT US</div>
                </div>
                <div class="about-desc content-text-font max-width1 center-block text-center">
                  <div class="">
                    陕西惠宾电子科技有限公司成立于2009年，总部位于古都西安。
                  </div>
                  <div class="">
                    公司成立十几年来深耕数字智慧医疗领域，是国内领先的数字智慧医疗解决方案提供商，是专业的“互联网+医疗健康”运营商。
                  </div>
                  <div class="">
                    惠宾科技致力于为医疗机构提供覆盖全流程诊疗、精细化管理、专业化运营的信息化和运营解决方案。
                  </div>
                  <div class="">
                    业务覆盖国内多个省市自治区，已有上百家三级医疗机构选择了我们的产品及运营服务，涵盖智慧门诊、智慧互联网医院、一站式患者服务平台和手术全流程管理等领域。
                  </div>
                </div>
                <div @click="goToPage('about')" class="more-text text-center cursor-pointer">
                  了解更多 >>
                </div>
              </div>
              <div class="grid-menu row"
              >
                <div class="col-xs-12 col-lg-3" v-for="(item, index) in aboutList" :key="index">
                  <div class="grid-item wow animate__animated animate__fadeInDown"
                  data-wow-delay="1s" data-wow-duration="1.5s"
                   :style="{ backgroundImage: `url(${item.url})` }">
                    <div class="number-text">
                      <animated-number ref="animatedNumber"
                        v-if="isAnimatedNumber"
                        class="num"
                        :formatValue="formatToPrice" 
                        :value="item.num" 
                        :to="item.num"
                        :delay="100"
                        :duration="1500"
                        ></animated-number>
                      <!-- <span class="num">{{ item.num }}</span> -->
                      <span class="unit">{{ item.unit }}</span>
                    </div>
                    <div class="text-font">{{ item.text }}</div>
                  </div>
                </div>
              </div>

              <!-- <div class="anli-button-box">
                <div class="anli-button1 cursor-pointer" @click="goToPage('cooperate')">免费使用</div>
							  <div class="anli-button2 cursor-pointer" @click="goToPage('cooperate')">在线咨询</div>
              </div> -->
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="product-bg w100 h100 flex-item-center">
            <div class="container relative ">
              <div class="content-box about-box">
                <div class="title-box text-center">
                  <div class="title">产品中心</div>   
                  <div class="subtitle">PRODUCT</div>
                </div> 
                <div class="product-content-box percentage6-top lg-flex sm-block row">
                  <div class="product-desc-box col-xs-12">
                      <div class="desc1">构建医院全场景</div>
                      <div class="desc2">创新医疗服务生态</div>
                      
                      <div @click="goToPage('product')" class="btn3 home-product-more">
                        了解更多
                        <img src="@/assets/img/more1.png" class="more-icon1" alt="" srcset="">
                      </div>
                    </div>
                  <div class="product-img-box col-xs-12">
                    <img src="../assets/img/product-img.png" @click="previewImage(require('@/assets/img/product-img.png'))" alt="" srcset="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="bg2 w100 h100 flex-item-center percentage2-top">
            <div class="container">
              <div class="content-box title-box text-center percentage4-top">
                <div class="title">核心优势</div>
                <div class="subtitle">ADVANTAGE</div>
              </div>
              <div class="youshi-grid row">
                <div class="col-lg-4 col-sm-6 col-xs-6" v-for="(item, index) in youshiList" :key="index">
                  <div class="youshi-item" @mouseover="youshiOver($event,index)" @mouseout="youshiOut">
                    <img :src="item.mainImg" class="youshi-img" alt="" srcset="" />
                    <div class="youshi-text-box">
                      <div class="youshi-text-title text-center">
                        <img :src="item.titleImg" class="titleImg" alt="" srcset="" />
                        {{ item.title }}
                      </div>
                      <div class="youshi-text-font text-center">
                        {{ item.text }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="bg1 w100 h100 flex-item-center">
            <div class="container">
              <div class="content-box title-box text-center percentage4-top">
                <div class="title">经典案例</div>
                <div class="subtitle">CASE</div>
              </div>
              <div class="anli-box">
                <div>
                  <div class="product-title-list">
                    <div class="product-title-item" :class="{
                      'active-title-item': index == activeAnliTitleIndex,
                    }" @click="anliTitleActive(index)" v-for="(item, index) in anliList" :key="index">
                      {{ item.title }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="img-desc-box clearfix xs-column flex-item-center flex-center"
                    v-for="(item, index) in anliList" :key="index"
                    v-show="index == activeAnliTitleIndex">
                      <img @click="previewImage(item.img1[0])" :src="item.img1[0]" alt="" srcset="" class="desc-img col-lg-6 col-sm-12 csl-xs-12" />
                      <div class="desc-text-content col-lg-6 col-sm-12 csl-xs-12">
                        <div class="">
                          <img :src="item.imgTitle" alt="" srcset="" />
                        </div>
                        <div class="yiyuan-title">{{ item.subTitle }}</div>
                        <div class="yiyuan-desc">
                          {{ item.desc }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="bottom-slide">
          <div class="bg2 w100 bottom-content-box">
            <div class="container bottom-content relative box-border">
              <div class="content-box title-box text-center percentage4-top box-border">
                <div class="title">资质荣誉</div>
                <div class="subtitle">OUR HONOR</div>
              </div>
            <rongyu-zizhi :imgList="zizhiImg"></rongyu-zizhi>
          </div>
          <bottom-footer class="bottom-footer"></bottom-footer>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination pull-swiper-pagination"></div>
    </div>
  </div>
</template>
<script>
import bottomFooter from "@/components/bottomFooter.vue";
import rongyuZizhi from "@/components/rongyu-zizhi.vue";
import shiyong from "@/components/shiyong.vue";
import AnimatedNumber from "animated-number-vue";
import { WOW } from "wowjs";
import { mapState,mapMutations } from 'vuex';

export default {
  name: "home",
  components: {
    bottomFooter,
    rongyuZizhi,
    shiyong,
    AnimatedNumber
  },
  
	computed: {
      ...mapState(['homeSwiperOption'])
  },
  data() {
    return {
      isAnimatedNumber:false,
      jingDianAnLiClass:"",
      slidesLength:-1,
      activeProductTitleIdx: 0,
      activeAnliTitleIndex: 0,

      pullSwiperOptions: {
        direction: "vertical",
        slidesPerView: 1,
        spaceBetween: 30,
        slidesPerView: 'auto',
        paginationClickable: true,
        keyboardControl: true,
        mousewheelControl: true,
        mousewheel: true,
        // effect : 'fade',
        // fadeEffect: {
        // 	crossFade: true,
        // },
        speed: 1500,
        pagination: {
          el: ".pull-swiper-pagination",
          type: "bullets",
          clickable: true,
          // direction: 'vertical',
        },
        on: {
        //   slideChange: () => {
        //     // const swiper = this.$refs.mySwiper.$swiper;
        //     // const activeIndex = swiper.activeIndex;

        //     this.setHomeSwiperOption({
        //       activeIndex:this.$refs.fullSwiper.swiper.activeIndex,
        //     })
        //     console.log('当前下标homeSwiperOption：', this.setHomeSwiperOption);
            
            
            
        //   },
          transitionStart:function(){
            console.log("回调函数transitionStart:",this);

          },
          transitionEnd: (swiper) => {
            console.log("回调函数transitionEnd:",swiper);
          }
        },
      },
      swiperOptions: {
        loop: true,
        speed:2000,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".banner-swiper-pagination",
          type: 'bullets',
          clickable: true,
        },
        on:{
          init: function(){
            swiperAnimateCache(this); //隐藏动画元素 
            swiperAnimate(this); //初始化完成开始动画
          }, 
          slideChangeTransitionEnd: function(){ 
            
            swiperAnimate(this); //每个slide切换结束时也运行当前slide动画
            // this.slides.eq(this.activeIndex).find('.ani').removeClass('ani');// 动画只展现一次，去除ani类名
          }
        }
      },
      swiperOptions1: {
        slidesPerView: 2,
        spaceBetween: "-80%",
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".anli-button-next",
          prevEl: "anli-button-prev",
        },
      },
      swiperOptions2: {
        slidesPerView: 3,
        loop: false,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // pagination: {
        //     el: '.swiper-pagination',
        //     type: 'fraction',
        //     clickable: true
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      imgList: [
        {
          url: require("@/assets/img/product1.png"),
        },
        {
          url: require("@/assets/img/product2.png"),
        },
        {
          url: require("@/assets/img/product3.png"),
        },
        {
          url: require("@/assets/img/product4.png"),
        },
      ],
      zizhiImg: [
        {
          url: require("@/assets/img/zizhi4.jpg"),
          title: "",
        },
        {
          url: require("@/assets/img/zizhi5.jpg"),
          title: "",
        },
        {
          url: require("@/assets/img/zizhi6.jpg"),
          title: "",
        },
      ],
      aboutList: [
        {
          url: require("@/assets/img/about1.png"),
          num: 15,
          unit: "年",
          text: "行业经验",
        },
        {
          url: require("@/assets/img/about2.png"),
          num: 69,
          unit: "%",
          text: "西安市场占有率",
        },
        {
          url: require("@/assets/img/about3.png"),
          num: 36,
          unit: "家",
          text: "三级医院",
        },
        {
          url: require("@/assets/img/about4.png"),
          num: 50,
          unit: "件",
          text: "知识产权",
        },
      ],
      youshiList: [
        {
          title: "专业专注",
          text: "惠宾自2009年成立以来专注智慧医疗的探索和开发",
          mainImg: require("@/assets/img/youshi7.png"),
        },
        {
          title: "产品成熟",
          text: "惠宾系列产品均为成熟产品拥有软件著作权登记证书39余项",
          mainImg: require("@/assets/img/youshi8.png"),
        },
        {
          title: "服务创新",
          text: "以节能增效为目标实现挂号支付、问诊、住院等流程再造",
          mainImg: require("@/assets/img/youshi9.png"),
        },
        {
          title: "案例优势",
          text: "合作医院数量100+其中军队医院12+",
          mainImg: require("@/assets/img/youshi10.png"),
        },
        {
          title: "资深团队",
          text: "经过10多年磨炼，打造了一批专业化的服务团队，并拥有多名行业资深专家",
          mainImg: require("@/assets/img/youshi11.png"),
        },
        {
          title: "服务闭环",
          text: "服务覆盖诊前、诊中、诊后模式支持产品、运营、孵化",
          mainImg: require("@/assets/img/youshi12.png"),
        },
      ],
      productCenterList: [
        {
          title: "互联网医院",
          content: {
            title: "互联网医院解决方案",
            desc: `互联网医院通过线上平台为医疗用户提供便捷高效的医疗服务，打破时空限制，实现无边界闭环医疗服务，核心功能包括挂缴查、在线问诊、处方开具、药品配送等功能。
以挂号、查询、缴费、排队、住院、在线诊疗、双向转诊等多种业务服务为中心，通过多介质应用、多渠道服务、多方式支付、多业务功能的应用为医院和患者提供便捷高效的服务。`,
            btnDesc: "查看更多",
            img1: require("@/assets/img/product6.png"),
          },
        },
        {
          title: "统一支付对账平台",
          content: {
            title: "互联网医院解决方案",
            desc: `互联网医院通过线上平台为医疗用户提供便捷高效的医疗服务，打破时空限制，实现无边界闭环医疗服务，核心功能包括挂缴查、在线问诊、处方开具、药品配送等功能。
						以挂号、查询、缴费、排队、住院、在线诊疗、双向转诊等多种业务服务为中心，通过多介质应用、多渠道服务、多方式支付、多业务功能的应用为医院和患者提供便捷高效的服务。`,
            btnDesc: "查看更多",
            img1: require("@/assets/img/product7.png"),
          },
        },
        {
          title: "全资源预约平台",
          content: {
            title: "互联网医院解决方案",
            desc: `互联网医院通过线上平台为医疗用户提供便捷高效的医疗服务，打破时空限制，实现无边界闭环医疗服务，核心功能包括挂缴查、在线问诊、处方开具、药品配送等功能。
						以挂号、查询、缴费、排队、住院、在线诊疗、双向转诊等多种业务服务为中心，通过多介质应用、多渠道服务、多方式支付、多业务功能的应用为医院和患者提供便捷高效的服务。`,
            btnDesc: "查看更多",
            img1: require("@/assets/img/product8.png"),
          },
        },
        // {
        // 	title: "智能消息资讯中心",
        // 					content:{
        // 						title:"互联网医院解决方案",
        // 						desc:`互联网医院通过线上平台为医疗用户提供便捷高效的医疗服务，打破时空限制，实现无边界闭环医疗服务，核心功能包括挂缴查、在线问诊、处方开具、药品配送等功能。
        // 	以挂号、查询、缴费、排队、住院、在线诊疗、双向转诊等多种业务服务为中心，通过多介质应用、多渠道服务、多方式支付、多业务功能的应用为医院和患者提供便捷高效的服务。`,
        // 						btnDesc:"查看更多"

        // 					}
        // }
      ],
      anliList: [
        {
          title: "医技预约",
          subTitle: "统一医技预约平台",
          imgTitle: require("@/assets/img/yiyuan-name2.png"),
          desc: "惠宾科技携手唐都医院，倾力打造了一套全面而先进的医疗信息化产品。这一系列包含号源管理、医技预约、排队叫号、预住院等功能，旨在为唐都医院的院方和广大患者提供卓越且便捷的服务体验。",
          img1: [require("@/assets/img/anli6.png")],
        },
        {
          title: "对账平台",
          subTitle: "统一对账平台",
          imgTitle: require("@/assets/img/yiyuan-name1.png"),
          img1: [require("@/assets/img/anli5.png")],
          desc: "惠宾科技凭借其卓越的技术实力，为西京医院精心构建了一个全面的医疗信息化解决方案。这一系统集成了号源管理、预住院服务、预约挂号、支付对账等多项关键功能，极大地提升了医院的服务质量和工作效率。",
        },
        {
          title: "互联网医院",
          subTitle: "互联网医院解决方案",
          imgTitle: require("@/assets/img/yiyuan1.png"),
          img1: [require("@/assets/img/product5.png")],
          desc: "互联网医院通过线上平台为医疗用户提供便捷高效的医疗服务，打破时空限制，实现无边界闭环医疗服务，核心功能包括挂缴查、在线问诊、处方开具、药品配送等功能",
        },
        {
          title: "导分诊",
          subTitle: "导分诊",
          imgTitle: require("@/assets/img/yiyuan-name3.png"),
          img1: [require("@/assets/img/anli7.png")],
          desc: "惠宾科技携手红会医院，共同打造了一个高效、智能的医疗信息化系统。这一系统集成了统一对账平台、患者服务平台、排队叫号以及统一号源管理等关键功能，旨在为医院提供全面而高效的信息化解决方案。",
        },
      ],
    };
  },
  created() {
    
  },
  mounted() {
    this.$nextTick(()=>{
      if(this.$platform.platformType()=='mobile'){
        this.isAnimatedNumber=true;
      }
    })
    
  },
  methods: {
    formatToPrice(value) {
      return `${value.toFixed(0)}`;
    },

    activeProductTitle(idx) {
      if (this.activeProductTitleIdx != idx) {
        this.activeProductTitleIdx = idx;
      }
    },
    anliTitleActive(idx) {
      this.jingDianAnLiClass="";
      if (this.activeAnliTitleIndex != idx) {
        this.activeAnliTitleIndex = idx;
      }
      let Timeout=setTimeout(()=>{
        this.jingDianAnLiClass="";
        // this.jingDianAnLiClass="animated pulse";
        clearTimeout(Timeout);
        Timeout=null;
      },300)
    },
    goToPage(type) {
      let url = "";
      if (type == "about") {
        url = "/about";
      } else if (type == "product") {
        url = "/productCenter";
      } else if (type == "cooperate") {
        url = "/cooperate";
      }
      if (url) {
        this.$router.push({
          path: url,
        });
      }
    },
    goPage() {
      this.$router.push({
        path: "/productCenter",
        query: {},
      });
    },
    onSlideChangeStart(swiper, event){
      // console.log("onSlideChangeStart:",);
      this.homeSwiperOption.swiperChangeState="start";

      if(this.homeSwiperOption.activeIndex<=this.slidesLength-1){
        this.setHomeSwiperOption({
          homeSwiperOption:this.homeSwiperOption
        })
      }
    },
    onSlideChangeEnd(swiper, event) {
      // console.log("回调函数onSlideChangeEnd:",swiper, event);
      this.homeSwiperOption.swiperChangeState="end";
      if(this.homeSwiperOption.activeIndex<=this.slidesLength-1){
        this.setHomeSwiperOption({
          homeSwiperOption:this.homeSwiperOption
        })
      } 
    },
    onSlideChange(){
      console.log("回调函数onSlideChange:",this.$refs.fullSwiper.swiper);
      
      this.homeSwiperOption.activeIndex=this.$refs.fullSwiper.swiper.activeIndex;
      this.slidesLength=this.$refs.fullSwiper.swiper.slides.length;
      if(this.$refs.fullSwiper.swiper.activeIndex>0){
        this.wowInit();

      }
      if(this.$platform.platformType()=='mobile' && this.$refs.fullSwiper.swiper.activeIndex==0){
        this.isAnimatedNumber=true;
        
      }
      if((this.$platform.platformType()=='mobile' && this.$refs.fullSwiper.swiper.activeIndex==0) || 
      this.$refs.fullSwiper.swiper.activeIndex==1){
        this.isAnimatedNumber=true;
      }else{
        this.isAnimatedNumber=false;
      }
      if(this.homeSwiperOption.activeIndex<=this.slidesLength){
        this.setHomeSwiperOption({
          homeSwiperOption:this.homeSwiperOption
        })
      }
    },
    wowInit(){
      this.$nextTick(() => {
        let wow=new WOW({
          boxClass: 'wow', // default
          animateClass: 'animated', // default
          offset: -60000, // default
          mobile: true, // default
          live: false,
        
          // live为true时，控制台会提示：MutationObserver is not supported by your browser. & WOW.js cannot detect dom mutations, please call .sync() after loading new content.
        
          callback: function (box) {
            console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
          }
        });
        wow.init();
      });
    },
    youshiOver(event,index){
      $(".youshi-item").eq(index).addClass('translateYTop');
    },
    youshiOut(event){
      $(".youshi-item").removeClass('translateYTop');
    },
    previewImage(e){
      layer.open({
        type: 1, 
        title:false,
        shadeClose:true,
        content: `<img class="w100" src="${e}">` //这里content是一个普通的String
      });
    },
    ...mapMutations(['setHomeSwiperOption'])
  },
};
</script>
<style scoped lang="scss">
@import url(../assets/css/swiper.min.css);
@mixin content-text-font{
	font-size: 1.6rem;
	color: #333333;
	font-weight: 400;
	font-family: Microsoft YaHei, Microsoft YaHei;
	font-weight: 400;
	line-height: 2.4rem;
}
.banner-swiper-pagination{
  bottom: 5% !important;
  left: 15% !important;
  ::v-deep .swiper-pagination-bullet{
    width: 1rem !important;
    height: 1rem !important;
    display: inline-block;
    margin-right: 1rem !important;
    background-color: #ffffff !important;
    // opacity: 1 !important;
  }
  ::v-deep .swiper-pagination-bullet-active{
    width: 2rem !important;
    border-radius: 0.5rem !important;
  }
}

.btn1 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22.4rem;
  height: 4.8rem;
  margin-top: 8.4rem;
  border-radius: 10rem;
  border: 1px solid #002880;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 1.6rem;
  color: #002880;
  cursor: pointer;

  &:hover {
    font-weight: 700;
  }
}

.btn2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22.4rem;
  height: 4.8rem;
  border-radius: 10rem;
  border: 1px solid #002880;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 1.6rem;
  color: #ffffff;
  background: #002880;
  cursor: pointer;

  &:hover {
    font-weight: 700;
  }
}

.btn3 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14rem;
  height: 4.8rem;
  font-weight: 400;
  font-size: 1.6rem;
  color: #FFFFFF;
  background: #087aff;
  border-radius: 0.8rem;
  cursor: pointer;

  &:hover {
    font-weight: 700;
  }
}
.btn4 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14rem;
  height: 4.8rem;
  font-weight: 400;
  font-size: 1.6rem;
  color: #FFFFFF;
  border-radius: 0.8rem;
  border: 1px solid #ffffff;
  background: transparent;
  cursor: pointer;

  &:hover {
    font-weight: 700;
  }
}
.product-bg{
  background-image: url(../assets/img/product-bg.jpg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
}
.banner-slide {
  position: relative;
  width: 100%;
  // height:calc(100vh - 6rem);
  height: 100%;
  // max-height: 58.2rem;
    // background-image: url(../assets/img/banner1.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  // align-items: flex-end;
  .banner-img{
    // position: absolute;
    // left: 0;
    // right:0;
    // top:0;
    // bottom:0;
  }
  .banner-desc-box {
    position: absolute;
    left: 15%;
    top: 30%;
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .desc1 {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 500;
      font-size: 5.1rem;
      color: #ffffff;
    }
    .desc2{
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 300;
      font-size: 3.2rem;
      color: #ffffff;
      .ai{
        color: #4CD7EE;
      }
    }
  }
}
.product-content-box{
  position: relative;
}
.product-desc-box{
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 30%;
  height: auto;
  font-size: 4rem;
  color: #333333;
  font-weight: 700;
  .desc1{
    
  }
  .desc2{

  }
}
.product-img-box{
  width: 70%;
  
}
.abs1{
  position: absolute;
  left: 15%;
  top: 60%;
  
}
.home-product-more{
  margin-top: 15.5rem;
}
.more-icon1 {
  width: 1.4rem;
  height: 1.4rem;
}

.banner-img1 {
  width: 100%;
  height: 100%;
}

.box {
  // height: 100%;
  position: relative;

  .swiper {
    // height: 100%;
    position: relative;

    .swiper-container {
      height: 100%;
    }

    .banner-container {
      height: 100%;
    }

    .pull-swiper-pagination {
      // display: flex;
      flex-direction: column;
      right: 2%;
      top: 50%;
      transform: translateY(-50%);
      width: 6px;
      
    }
  }
}

.max-width1 {
  // max-width: 96.2rem;
}

.swiper {
  position: relative;

  .swiper-button-prev {
    position: absolute;
    width: 4.8rem;
    height: 4.8rem;
    left: -2rem;
    background-color: rgba(153, 153, 153, 0.6);
    background-size: 60% 60%;
    border-radius: 50%;
  }

  .swiper-button-next {
    width: 4.8rem;
    height: 4.8rem;
    right: -2rem;
    background-color: rgba(153, 153, 153, 0.6);
    background-size: 60% 60%;
    border-radius: 50%;
  }
}

.pull-swiper-box {
  width: 100%;
  height: 100%;

  .swiper-containe {
    width: 100%;
    height: 100%;

    .swiper-wrapper {
      width: 100%;
      height: 100%;
    }

    .swiper-slide {
      width: 100%;
      height: 100%;
    }
  }
}

.content-title {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 1.8rem;
  color: #333333;
}

.title {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 3.6rem;
  color: #333333;
}

.subtitle {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 1.4rem;
  color: #999999;
}
.more-text {
  margin-top: 3.8rem;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 1.6rem;
  color: #002880;

  &:hover {
    font-weight: 700;
  }
}

.product-title-list {
  display: flex;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 3.8rem;
  padding-bottom: 7.5rem;
  justify-content: space-between;

  .product-title-item {
    cursor: pointer;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 1.6rem;
    color: #333333;
  }

  .active-title-item {
    color: #002880;
    padding-bottom: 1.2rem;
    border-bottom: 4px solid #002880;
  }
}

.grid-menu {
  margin-top: 7.8rem;

  .grid-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 21rem;
    border-radius: 0.8rem;
    // margin-left: -1rem;
    // margin-right: -1rem;
    background-size: 100% 100%;
    transition: background-size 0.5s ease;

    /* 平滑过渡效果 */
    // overflow: hidden; /* 确保放大背景时不会超出容器 */
    &:hover {
      background-size: 120% 120%;
      /* 放大背景至120% */
    }

    .number-text {
      .num {
        font-family: DIN, DIN;
        font-weight: 400;
        font-size: 4.8rem;
        color: #ffffff;
      }

      .unit {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 1.4rem;
        color: #ffffff;
      }
    }

    .text-font {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 1.6rem;
      color: #ffffff;
    }
  }
}

.anli-grid {
  padding-top: 7.2rem;

  .anli-content {
    display: flex;
    flex-direction: column;
    // align-items: center;
    justify-content: center;
    height: 37.2rem;
    overflow: hidden;
    border-top-right-radius: 3rem;
    border-bottom-right-radius: 3rem;
    background-color: #f5f5f7;
  }

  .abli-item {
    margin-left: -1.5rem;

    .anli-img {
      width: 50%;
    }

    .anli-title {
      margin-bottom: 2rem;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 2.6rem;
      color: #333333;
    }

    .anli-text {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 1.4rem;
      color: #333333;
    }
  }
}

.anli-list {
  display: flex;
  justify-content: center;
  margin-top: 6.6rem;

  .anli-list-img {
    width: 100%;
  }
}

.anli-button-box {
  display: flex;
  justify-content: center;
  padding-top: 7.8rem;
  padding-bottom: 8.7rem;

  .anli-button1 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 15rem;
    height: 4.8rem;
    margin-right: 3.3rem;
    background: #002880;
    border-radius: 10rem;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 1.6rem;
    color: #ffffff;

    &:hover {
      font-weight: 700;
    }
  }

  .anli-button2 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 15rem;
    height: 4.8rem;
    border-radius: 10rem;
    border: 1px solid #999999;
    background: #ffffff;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 1.6rem;
    color: #666666;

    &:hover {
      font-weight: 700;
    }
  }
}


.youshi-grid {
  padding-top: 8.2rem;
  padding-bottom: 6.2rem;

  .youshi-item {
    
    height: 20rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 7.5rem 5rem 7.5rem;
    background-color: #ffffff;
    margin-bottom: 9.5rem;
    box-sizing: border-box;
    box-shadow: 0 1rem 4rem 0.1rem rgba(187, 186, 186 , 16%);
    cursor: pointer;
    transition: all 0.5s ease-in-out;
    .youshi-img {
      width: 12rem;
      height: 11.2rem;
      margin-top: -5.5rem;
    }

    .youshi-text-title {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: bold;
      font-size: 1.8rem;
      color: #333333;
    }

    .youshi-text-font {
      padding-top: 1rem;
      @include content-text-font;
    }
  }
}
.translateYTop{
  box-shadow: 0 15px 30px rgba(0,0,0,0.1);
  transform: translate3d(0, -3rem, 0);
}
.anli-box {
  padding-bottom: 14.8rem;

  .swiper-box {
    position: relative;
  }

  .swiper-container {
    .swiper-slide {
      transition: transform 1s;
      transform: scale(0.8);
      position: relative;
      height: 42.4rem;
    }

    .swiper-slide-active {
      transform: scale(1);
      z-index: 2;
    }

    .swiper-slide img {
      width: 100%;
      height: 100%;
      border-radius: 1.5rem;
      display: block;
    }
  }
}
.product-item-box {
  padding-bottom: 15.3rem;
}

.img-desc-box {
  .desc-text-content {
    .yiyuan-title {
      margin-top: 1.8rem;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: bold;
      font-size: 1.8rem;
      color: #002880;
    }
    .yiyuan-desc {
      margin-top: 1.8rem;
      @include content-text-font;
    }
    
  }
  .desc-img{
    max-width: 50rem;
    // height: 33.4rem;
  }
}

.banner-desc-img{
  position: absolute;
  top: 0%;
  left: 5%;
}
.bottom-footer-box{
  display: flex;
  flex-direction: column;
}
.bottom-content-box{
  display: flex;
  flex-direction: column;
  // align-items: center;
  // justify-content: center;
  min-height: 100%;
  
}
.bottom-slide{
  // height: auto !important;
  // min-height: 100%;
}
.bottom-content{
  // min-height: 70vh;
  flex: 4;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.bottom-footer{
  // min-height: 42%;
  flex: 1;
}
// .swiper-slide-active {
//     height: auto !important;
//     min-height: 100%;
// }
.zizhi-more-btn{
  position: absolute;
  left: 50%;
  bottom: 3%;
  transform: translateX(-50%);
  z-index: 3;
}
.about-desc{
  padding-top: 5vh;
}
</style>
